const House = (
    <g>
        <path d="m15.999 7.75c-.156 0-.314-.049-.449-.15l-6.54999-4.912-6.55 4.912c-.331.25-.803.181-1.05-.15-.249-.332-.182-.802.149-1.05l7.001-5.25c.268-.2.633-.2.9 0l6.99999 5.25c.331.249.398.719.149 1.05-.146.196-.371.3-.6.3z" />
        <path d="m14.649 8.80001-5.649-4.238-5.649 4.238c-.111.083-.229.152-.351.213v5.23699c0 1.517 1.233 2.75 2.75 2.75h2.5v-3.75c0-.414.336-.75.75-.75s.75.336.75.75v3.75h2.5c1.517 0 2.75-1.233 2.75-2.75v-5.23699c-.122-.061-.24-.13-.351-.213z" />
    </g>
);

export { House };
